import { extends as _extends } from '../../../_virtual/_rollupPluginBabelHelpers.js';
import { forwardRef, createElement } from 'react';
import Box from '../../Box/index.esm.js';

var Track = /*#__PURE__*/forwardRef(function (props, ref) {
  return createElement(Box, _extends({
    ref: ref,
    position: "relative",
    flex: "flex-1",
    height: "h-1",
    dangerouslySetClassName: "range-input__track"
  }, props));
});

export default Track;
//# sourceMappingURL=index.esm.js.map
